import React, { useEffect, useState } from "react";
import { Col, Row, Select, Spin } from "antd";
import { Controller } from "react-hook-form";
import CustomTextfield from "../../../../../../common/input/custom-textfield/custom-textfield";
import CustomSelect from "../../../../../../common/input/custom-select/custom-select";
import { createAntdSelection } from "../../../../../../utils/common";
import { fetchSubjects } from "../../../../../../services/student";

const TeacherSchoolInformation = ({ control }) => {
  const [loading, setLoading] = useState(false);
  const [subjects, setSubjects] = useState([]);

  useEffect(() => {
    (async () => {
      try {
        setLoading(true);
        const resp = await fetchSubjects();
        const subjects = createAntdSelection(resp?.data?.data?.subjects ?? []);
        setSubjects(subjects);
      } catch (err) {
        console.log(err);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  return (
    <Spin spinning={loading}>
      <Row gutter={[32, 20]}>
        <Col span={12}>
          <Controller
            name="subjects_taught"
            control={control}
            render={({ field: { onChange, value }, fieldState: { error } }) => (
              <CustomSelect
                mode="multiple"
                id="subjects_taught"
                label="Select Subjects Taught"
                showRequired
                labelColor="#171717"
                placeholder="--Select--"
                size="large"
                value={value}
                onChange={onChange}
                status={error ? "error" : ""}
              >
                {subjects?.map((item, index) => (
                  <Select.Option key={index} value={item?.value}>
                    {item?.label}
                  </Select.Option>
                ))}
              </CustomSelect>
            )}
          />
        </Col>

        <Col span={12}>
          <Controller
            name="designation"
            control={control}
            render={({ field: { onChange, value }, fieldState: { error } }) => (
              <CustomTextfield
                id="designation"
                label="Designation"
                showOptional
                labelColor="#171717"
                placeholder="Enter designation"
                size="large"
                value={value}
                onChange={onChange}
                status={error ? "error" : ""}
              />
            )}
          />
        </Col>
      </Row>
    </Spin>
  );
};

export default TeacherSchoolInformation;
